import { useI18n } from '@whizz/react-i18n';
import { getIconComponent } from '../../../../../util/reactFunc';
import { ChoiceGroup, Tag, Toggle } from '../../../../../components';
import React from 'react';

export const ActiveToggle = (
  {
    onChange,
    checked,
  }: { onChange: (checked: boolean) => void, checked: boolean },
): JSX.Element => {
  const { translate } = useI18n();

  return (
    <div className={'flex flex-nowrap items-center space-x-6 -ml-2'}>
      <button
        type={'button'}
        className={'appearance-none flex items-center'}
        onClick={() => onChange(true)}
      >
        {getIconComponent('Lightbulb', 40, 'secondary')}
        {translate('pages.ROSTER_MANAGEMENT.STUDENTS.ADD_EDIT.ACTIVE')}
      </button>
      <div className={'mx-sm'}>
        <Toggle
          id={'student-active'}
          label={'Active'}
          color={'dark'}
          onChange={(event) => onChange(event.target.checked)}
          checked={checked}
          isInverted
        />
      </div>
      <button
        type={'button'}
        className={'appearance-none flex items-center'}
        onClick={() => onChange(false)}
      >
        {getIconComponent('LightbulbOff', 40, 'muted')}
        {translate('pages.ROSTER_MANAGEMENT.STUDENTS.ADD_EDIT.INACTIVE')}
      </button>
    </div>
  );
};

export const TagCheckbox = ({ $color, ...props }: { $color: number } & React.ComponentProps<typeof ChoiceGroup>): JSX.Element => (
  <div className={'flex gap-2'}>
    <ChoiceGroup
      hideLabel
      {...props}
    />
    <Tag color={$color} className={'w-full'}>{props.label}</Tag>
  </div>
);
